import { render, staticRenderFns } from "./SubscribersEdit.vue?vue&type=template&id=3e2ec745&lang=pug"
import script from "./SubscribersEdit.vue?vue&type=script&lang=ts"
export * from "./SubscribersEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports